/**
 * 用于所有页面初始化逻辑
 * 处理登录逻辑
 * 处理首屏 接口请求
 * 埋点注册
 * 什么时候展示首屏元素
 */
'use client';
import React from 'react';

import { usePathname } from 'next/navigation';
import SidebarContent from './SidebarContent';
import Header from './Header';
import {
  ConfirmProvider,
  RightTabsModel,
  RightTabsModelProvider,
  Sidebar,
  SidebarProvider,
  useSidebar,
} from '@whelk/components';
import { BgIcon, BgIconDark } from './bg-icon';
import { RootState } from '@whelk/store';
import { useSelector } from 'react-redux';
import { useTheme } from 'next-themes';
import usePageName from '@whelk/hooks/src/usePageName';

const Layout = ({ children }: { children: React.ReactElement }) => {
  const path = usePathname();

  const isHome = path === '/';

  return (
    <section className='bg-col_bg09 flex h-[--screen] w-full overflow-hidden'>
      <SidebarProvider>
        <LayoutContent isHome={isHome}>{children}</LayoutContent>
      </SidebarProvider>
    </section>
  );
};
// 将使用 Context 的逻辑移到单独的组件中
const LayoutContent = ({ children }: { children: React.ReactElement; isHome: boolean }) => {
  const { statusBarHeight, navigationBarHeight } = useSelector(
    (state: RootState) => state.config.nativeStyle,
  );
  const { isHistoryPage } = usePageName();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const { handleTouchStart, handleTouchMove, handleTouchEnd } = useSidebar();
  const isShareSelecting = useSelector((state: RootState) => state.chat.isShareSelecting);
  const style = {
    paddingTop: `${statusBarHeight}px`,
    paddingBottom: `${navigationBarHeight || 12}px`,
  };
  // 对话页面 & 历史页面 才会需要

  return (
    <ConfirmProvider>
      <div className='flex w-full'>
        <Sidebar style={style}>
          <SidebarContent />
        </Sidebar>
        <div
          className='app-footer relative flex h-[--screen] min-w-[100vw] flex-1 flex-row overflow-hidden md:w-full md:min-w-0'
          style={style}
        >
          {!isShareSelecting && !isHistoryPage ? (
            isDark ? (
              <div
                className='pointer-events-none absolute bottom-0 left-0 z-[1000] w-full md:hidden'
                aria-hidden='true'
              >
                <BgIconDark />
              </div>
            ) : (
              <div
                className='pointer-events-none absolute left-0 top-0 w-full md:hidden'
                aria-hidden='true'
              >
                <BgIcon />
              </div>
            )
          ) : null}
          <section className='flex h-full w-full flex-col overflow-hidden'>
            {!isShareSelecting && <Header />}

            <RightTabsModelProvider>
              <div className='flex w-full flex-1 overflow-hidden '>
                <div
                  className='flex w-full flex-1 overflow-hidden'
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                >
                  {children}
                </div>

                <RightTabsModel />
              </div>
            </RightTabsModelProvider>
          </section>
        </div>
      </div>
    </ConfirmProvider>
  );
};

export { Layout };
